// extracted by mini-css-extract-plugin
export default {"sideMenu":"Side_sideMenu__1msI6","menuItem":"Side_menuItem__zDucz","active":"Side_active__0jGqY"};